module.exports = __webpack_public_path__ + "static/img/7.0efde79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ajbz/7.png
// module id = QUlz
// module chunks = 0